import { Injectable } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KnBrQuotesService } from 'src/feature-libs/kn-br-cart/saved-carts/core/facade/kn-br-quotes.service';

@Injectable({
  providedIn: 'root',
})
export class KnBrMyQuotePageLayoutHandler implements PageLayoutHandler {
  code: string;
  constructor(private routingService: RoutingService, private knBrQuoteService: KnBrQuotesService) { }

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'KnBrStep2CustomerQuoteDetailPageTemplate' && !section) {
      this.routingService.getRouterState().subscribe((state) => {
        if (state && state.state && state.state.params && state.state.params.code) {
          this.code = state.state.params.code;
          this.knBrQuoteService.get$.subscribe((quote) => {
            if (!quote) {
              this.knBrQuoteService.get(this.code);
            }
          });
        }
      });
      return combineLatest([slots$, this.knBrQuoteService.get$]).pipe(
        map(([slots, quote]) => {
          const exclude = (arr, args) => arr.filter((item) => args.every((arg) => arg !== item));
          if (
            quote?.statusKey === 'APPROVED' ||
            quote?.statusKey === 'REJECTED' ||
            quote?.statusKey === 'PENDING_CUSTOMER_CONSENT' ||
            quote?.statusKey === 'ORDERED'
          ) {
            slots = exclude(slots, ['KnBrStep2CustomerQuoteActionBarSlot']);
          }
          if (quote && quote.code && quote.entries) {
            return quote && Object.keys(quote).length === 0
              ? exclude(slots, ['KnBrStep2CustomerEmptyCartSlot'])
              : quote?.totalItems
                ? exclude(slots, ['KnBrStep2CustomerEmptyCartSlot'])
                : quote?.totalItems
                  ? exclude(slots, ['KnBrStep2CustomerEmptyCartSlot'])
                  : exclude(slots, ['KnBrStep2CustomerQuoteActionBarSlot', 'KnBrStep2CustomerQuoteItemsSlot']);
          } else {
            return exclude(slots, ['KnBrStep2CustomerEmptyCartSlot']);
          }
        })
      );
    }
    return slots$;
  }
}
